<template>
  <Toast />
  <div class="card-header">
    <h4>Listado de Usuarios</h4>
    <div class="line_title"></div>
  </div>
  <div class="card-body">
    <div>      
      <!-- DT Usuarios -->
      <DataTable ref="dt" :value="users" :paginator="true" :rows="10" style="zoom: 0.80;" :loading="loading" 
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" :filters="filters"
        v-model:selection="selectedUsers" responsiveLayout="scroll" breakpoint="990px">
        <template #header>          
          <!-- DT Toolbar-->
          <Toolbar class="">
            <template #start>
              <div class="table-header flex flex-column md:flex-row md:justiify-content-between">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                </span>
              </div>
            </template>
            <template #end>
              <Button label="Crear" icon="pi pi-plus" class="p-button-success" @click="openNew" />
              &nbsp;
              <Button label="Borrar" icon="pi pi-trash" class="p-button-danger" @click="confirmDeleteSelected" :disabled="!selectedUsers || !selectedUsers.length" />
              &nbsp;  
              <Button label="Descargar" icon="pi pi-download" class="p-button-help" @click="exportCSV($event)" />
            </template>
          </Toolbar>
        </template>

        <Column selectionMode="multiple" style="width: 3rem" :exportable="false"></Column>

        <Column field="rut_dv" header="RUT"  style="white-space: nowrap;">
          <template #body="slotProps">
            <span>
              {{ slotProps.data.rut_dv }}
            </span>
          </template>
        </Column>
        <Column field="name" header="Nombre" >
          <template #body="slotProps">
            <span>
              {{ slotProps.data.name }}
            </span>
          </template>
        </Column>
        <Column field="email" header="Email" >
          <template #body="slotProps">
            <span>
              {{ slotProps.data.email }}
            </span>
          </template>
        </Column>
        <Column field="seg_rol_id.nombre" header="Rol" >
          <template #body="slotProps">
            <span>
              {{ slotProps.data.seg_rol_id.nombre }}
            </span>
          </template>
        </Column>
        <Column field="vigente" header="Estado" >
          <template #body="slotProps">
            <Tag :value="slotProps.data.vigente ? 'ACTIVO' : 'INACTIVO'" :severity="slotProps.data.vigente ? 'success' : 'danger'" />
          </template>
        </Column>
        <Column header="Acciones" :exportable="false" style="white-space: nowrap;">
          <template #body="slotProps">
            <Button icon="pi pi-pencil" class="p-button-rounded p-button-warning"
              @click="editUser(slotProps.data)" />&nbsp;
            <Button icon="pi pi-trash" class="p-button-rounded p-button-danger"
              @click="confirmDeleteUser(slotProps.data)" />
          </template>
        </Column>
      </DataTable>
    </div>

    <!-- Formulario Usuarios en modal -->
    <Dialog v-model:visible="userDialog" :style="{ width: '50%' }" header="Datos del Usuario" :modal="true"
      class="p-fluid" :maximizable="true">

      <form class="p-fluid">
        <div class="row">
          <div class="col-md-5 field">
            <label for="rut_dv" class="mt-3">RUT</label>
            <InputText id="rut_dv" v-model="v$.rut_dv.$model"
              :class="{ 'p-invalid': v$.rut_dv.$invalid && submitted }" aria-describedby="rut_dv-error" autofocus
              autocomplete="off" />
            <span v-if="v$.rut_dv.$error && submitted">
              <span id="rut_dv-error" v-for="(error, index) of v$.rut_dv.$errors" :key="index">
                <small class="p-error">{{ error.$message }} </small>
              </span>
            </span>
            <small v-else-if="(v$.rut_dv.$invalid && submitted) || v$.rut_dv.$pending.$response" class="p-error">
              {{ v$.rut_dv.required.$message.replace('Value', 'RUT') }}</small>
          </div>

          <div class="col-md-7 field">
            <label for="name" class="mt-3">Nombre</label>
            <InputText id="name" v-model="v$.name.$model" :class="{ 'p-invalid': v$.name.$invalid && submitted }"
              aria-describedby="name-error" autofocus autocomplete="off" />
            <span v-if="v$.name.$error && submitted">
              <span id="name-error" v-for="(error, index) of v$.name.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.name.$invalid && submitted) || v$.name.$pending.$response" class="p-error">
              {{ v$.name.required.$message.replace('Value', 'Nombre') }}</small>
          </div>
        </div>

        <div class="row">
          <div class="col-md-7 field" >
            <label for="email" class="mt-3">Email</label>
            <InputText id="email" v-model="v$.email.$model"
              :class="{ 'p-invalid': v$.email.$invalid && submitted }" aria-describedby="email-error"
              autocomplete="off" />
            <span v-if="v$.email.$error && submitted">
              <span id="email-error" v-for="(error, index) of v$.email.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.email.$invalid && submitted) || v$.email.$pending.$response" class="p-error">
              {{ v$.email.required.$message.replace('Value', 'Email') }}</small>
          </div>
          <div class="col-md-5 field">
            <label for="ccelular" class="mt-3">Celular</label>
            <InputText id="ccelular" v-model.trim="form.telefono_movil" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 field" >
            <label for="password" class="mt-3">Clave</label>
            <Password id="password" v-model="v$.password.$model"
              :class="{ 'p-invalid': v$.password.$invalid && submitted }" aria-describedby="password-error"
              autocomplete="off" toggleMask />
            <span v-if="v$.password.$error && submitted">
              <span id="password-error" v-for="(error, index) of v$.password.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.password.$invalid && submitted) || v$.password.$pending.$response" class="p-error">
              {{ v$.password.required.$message.replace('Value', 'Clave') }}</small>
          </div>          
          <div class="col-md-4 field">
            <label for="seg_rol_id" class="mt-3">Rol</label>
            <AutoComplete id="seg_rol_id" v-model="v$.seg_rol_id.$model"
              :class="{ 'p-invalid': v$.seg_rol_id.$invalid && submitted }" :suggestions="filteredRoles"
              @complete="searchRol($event)" field="nombre" :dropdown="true" forceSelection
              aria-describedby="seg_rol_id-error" autofocus autocomplete="off" />
            <span v-if="v$.seg_rol_id.$error && submitted">
              <span id="seg_rol_id-error" v-for="(error, index) of v$.seg_rol_id.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="((v$.seg_rol_id.$invalid && submitted) || v$.seg_rol_id.$pending.$response)"
              class="p-error">
              {{ v$.seg_rol_id.required.$message.replace('Value', 'Rol') }}</small>
          </div>          
          <div class="col-md-4 field">
            <label for="vigente" class="mt-3">Estado</label><br>
            <ToggleButton id="vigente" v-model="v$.vigente.$model"
              :class="{ 'p-invalid': v$.vigente.$invalid && submitted }" onLabel="ACTIVO" offLabel="INACTIVO"
              onIcon="pi pi-check" offIcon="pi pi-times" aria-describedby="vigente-error" autofocus
              style="width: 100%" />
            <span v-if="v$.vigente.$error && submitted">
              <span id="vigente-error" v-for="(error, index) of v$.vigente.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.vigente.$invalid && submitted) || v$.vigente.$pending.$response" class="p-error">
              {{ v$.vigente.required.$message.replace('Value', 'Estado') }}</small>
          </div>
        </div>
      </form>
      <template #footer>
        <div class="row">
          <div class="col-md-7 fw-lighter text-muted" style="text-align: left;">
            <small v-if="form.created_id" ><i class="pi pi-user-plus" style="font-size: 1rem"></i>: {{form.created_id.name}} el {{form.created_at}}</small><br/>
            <small v-if="form.updated_id"><i class="pi pi-user-edit" style="font-size: 1rem"></i>: {{form.updated_id.name}} el {{form.updated_at}}</small>    
          </div>  
          <div :class="form.created_id ? 'col-md-5 field' : 'col-md-12 field'" v-if="!saving">
            <Button label="Cancelar" icon="pi pi-times" class="p-button-text text-danger" @click="hideDialog" />
            <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="saveUser" />
          </div>
          <div :class="form.created_id ? 'col-md-5 field' : 'col-md-12 field'" v-else>
            <ProgressBar mode="indeterminate"/>
          </div>
        </div>
      </template>
    </Dialog>

    <!-- Confirmar elimina un usuario -->
    <Dialog v-model:visible="deleteUserDialog" :style="{ width: '470px' }" header="Confirmar" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-3 text-warning" style="font-size: 2rem; vertical-align: middle;" />
        <span v-if="user"> ¿Está seguro de borrar el usuario?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteUserDialog = false" />
        <Button label="Si" icon="pi pi-check" class="p-button-text text-danger" @click="deleteUser" />
      </template>
    </Dialog>

    <!-- Confirmar elimina masivamente usuarios -->
    <Dialog v-model:visible="deleteUsersDialog" :style="{ width: '470px' }" header="Confirmar" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-2 text-warning" style="font-size: 2rem; vertical-align: middle;" />
        <span v-if="selectedUsers"> ¿Está seguro de borrar los usuarios seleccionados?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteUsersDialog = false" />
        <Button label="Si" icon="pi pi-check" class="p-button-text text-danger" @click="deleteSelectedUsers" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import useUsers from '../../composables/seguridad/users'
import { reactive, onMounted } from 'vue'

import useVuelidate from '@vuelidate/core'
import { required, email, helpers, requiredIf } from '@vuelidate/validators'

export default {
  setup() {
    const {
      user,
      users,
      roles,
      dt, 
      loading, 
      saving,
      filters,
      selectedUsers,
      deleteUsersDialog,
      deleteUserDialog,
      userDialog,
      submitted,
      filteredRoles,
      storeUser,      
      deleteSelectedUsers,
      getCRUD,
      deleteUser
    } = useUsers()

    const form = reactive({
      rut_dv: '',
      name: '',
      email: '',
      password: '',
      telefono_movil: '',
      seg_rol_id: '',
      vigente: ''
    })

    const rut_format = helpers.regex(/^(\d{1,3}(?:\d{1,3}){2}-[\dkK])$/)
    
    const rules = {
      rut_dv: {
        required: helpers.withMessage('El campo es requerido o no corresponde al usuario', required),
        rut_rule: helpers.withMessage('Ingrese un rut válido. Ej: 12345678-0', rut_format),
      },
      name: { required: helpers.withMessage('El campo es requerido', required), },
      telefono_movil: { required: helpers.withMessage('El campo es requerido', required), },
      password: { required: helpers.withMessage('El campo es requerido', required), },
      email: {
        required: helpers.withMessage('El campo es requerido!', required),
        email: helpers.withMessage('Ingrese un email válido. Ej: buzon@transcon.com', email),
      },
      seg_rol_id: { required: helpers.withMessage('El campo es requerido', required) },
      vigente: { required: helpers.withMessage('El campo es requerido', required) }
    }

    const exportCSV = () => {
      console.info(dt.value)
      dt.value.exportCSV()
    }

    const confirmDeleteSelected = () => {
      deleteUsersDialog.value = true
    }

    const confirmDeleteUser = (usr) => {
      user.value = usr
      deleteUserDialog.value = true
    }

    const openNew = () => {
      user.value = {}
      submitted.value = false
      userDialog.value = true
      saving.value = false

      form.rut_dv = ''
      form.name = ''
      form.email = ''
      form.password = ''
      form.telefono_movil = ''
      form.seg_rol_id = ''
      form.vigente = ''

      form.created_at = ''
      form.created_id = ''
      form.updated_at = ''
      form.updated_id = ''     
    }

    const hideDialog = () => {
      userDialog.value = false
      submitted.value = false
      saving.value = false
    }

    const formatRol = (value) => {
      if (value)
        return value.nombre
      return
    }

    const searchRol = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredRoles.value = [...roles.value]
        }
        else {
          filteredRoles.value = roles.value.filter((rol) => {
            return rol.nombre.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const editUser = (usr) => {
      user.value = { ...usr }
      userDialog.value = true

      form.rut_dv = user.value.rut_dv
      form.name = user.value.name
      form.email = user.value.email
      form.password = '*********'
      form.telefono_movil = user.value.telefono_movil

      form.seg_rol_id = user.value.seg_rol_id
      form.vigente = user.value.vigente
      
      form.created_at = user.value.created_at
      form.created_id = user.value.created_id
      form.updated_at = user.value.updated_at
      form.updated_id = user.value.updated_id
    }

    const saveUser = () => {
      submitted.value = true
      if(!v$._value.$invalid){
        storeUser(form)               
      }
    }

    const v$ = useVuelidate(rules, form)

    onMounted(getCRUD)

    return {
      dt, 
      loading,
      saving,
      user,
      users,
      roles,
      filters,
      selectedUsers,
      deleteUsersDialog,
      deleteUserDialog,
      userDialog,
      submitted,
      filteredRoles,
      v$,
      form,
      formatRol,
      hideDialog,
      openNew,
      confirmDeleteUser,
      deleteSelectedUsers,
      deleteUser,
      exportCSV,
      confirmDeleteSelected,
      searchRol,
      editUser,
      saveUser,
      storeUser
    }
  },
}
</script>